<template>
    <div>oi</div>
</template>

<script>
    export default {
        name: "Home",
    };
</script>
